import React from 'react';
import { Canvas } from 'fabric';
import { Upload, ImageIcon, FileVideo2Icon, Music } from 'lucide-react';
import { useImageUpload } from '../hooks/use-image-upload';
import { useVideoUpload } from '../hooks/use-video-upload';
import { useAudioUpload } from '../hooks/use-audio-upload';
import { useMedia } from '../hooks/use-media';
import { useResolutions } from '../../resolution/hooks/use-resolutions';
import { FlyoutTab } from '../../editor-shell/components/flyout-tab';

type UploadButtonProps = {
  canvas: Canvas | null;
};

export const UploadButton: React.FC<UploadButtonProps> = ({ canvas }) => {
  const { registerVideo, trackMediaLoad } = useMedia();
  const { activeResolution } = useResolutions();
  const dw = activeResolution.canvasWidth;
  const dh = activeResolution.canvasHeight;
  const image = useImageUpload(canvas, dw, dh, 'cover');
  const video = useVideoUpload(canvas, registerVideo, trackMediaLoad, dw, dh, 'cover');
  const audio = useAudioUpload();

  return (
    <>
      <input
        ref={image.inputRef}
        type='file'
        accept='image/png, image/jpeg, image/webp'
        onChange={image.handleChange}
        style={{ display: 'none' }}
      />
      <input
        ref={video.inputRef}
        type='file'
        accept='video/*'
        onChange={video.handleChange}
        style={{ display: 'none' }}
      />
      <input
        ref={audio.inputRef}
        type='file'
        accept='audio/*'
        onChange={audio.handleChange}
        style={{ display: 'none' }}
      />

      <FlyoutTab
        panelId='upload'
        label='Subir'
        icon={<Upload size={18} />}
        items={[
          { label: 'Imagen', icon: <ImageIcon size={18} />, onClick: image.open },
          { label: 'Video', icon: <FileVideo2Icon size={18} />, onClick: video.open },
          { label: 'Audio', icon: <Music size={18} />, onClick: audio.open }
        ]}
      />
    </>
  );
};
